export const mbData = [
  {
    name: "Irma Veranita",
    email: "irmaanakbaik@gmail.com",
    anggota: null,
    code: "BGR 0001",
    jenis: "MB",
    alamat:
      "Ruko cibubur country blok rboh-7 , jalan cibubur country boulevard . Cikeas kec gn.putri bogor jawabarat 16966",
    nohp: "81212411811",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Yairus Wora",
    email: "yairus.bintangtimur2003@gmail.com",
    anggota: null,
    code: "BKS 0001",
    jenis: "MB",
    alamat:
      "Ruko kavling taman wisata blok A14 no.10 Pondok Ungu Permai, kel. Bahagia, kec. Babelan, kab. Bekasi 17610",
    nohp: "85774253939",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Andi Firdaus Syaifullah",
    email: "andifirdauslnv@gmail.com",
    anggota: "IPCN",
    code: "BKS 0002",
    jenis: "MB",
    alamat:
      "Jl. Alteri jor, No 8 RT. 005/004 Kel. Jati Warna Kec. Pondok Melati, Bekasi 17415",
    nohp: "081259002100",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Abi Habibi",
    email: "cv.berkahsuksesexpress@gmail.com",
    anggota: "IPCN",
    code: "BKS 0003",
    jenis: "MB",
    alamat:
      "Jl MT Haryono No 19 RT 002 RW 006 Desa Burangkeng Kec Setu Kab Bekasi 17320 (Sebrang Bank Mandiri Setu)",
    nohp: "081977815189",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Budi Santoso SE",
    email: "sbudi159@gmail.com",
    anggota: null,
    code: "DPK 0001",
    jenis: "MB",
    alamat:
      "Griya statistika Blok 2C no15 RT 004/013 Kel. Cilangkap Kec. Tapos Depok 16458",
    nohp: "85810021546",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Decky",
    email: "dec121006@yahoo.com",
    anggota: null,
    code: "JKT 0001",
    jenis: "MB",
    alamat:
      "Ruko bertingkat pagar hijau, Jl. Pisangan Lama No.7, RT.1/RW.2, Kel. Pisangan Timur Kec. Pulo Gadung, Jakarta Timur 13230",
    nohp: "82122200703",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Saladin Wiratama",
    email: "adindigger@gmail.com",
    anggota: null,
    code: "JKT 0002",
    jenis: "MB",
    alamat:
      "JL. Taman Malaka Utara Blok B2 No. 34. Pondok Kelapa Kel. Malaka Sari Kec. Duren Sawit Jakarta Timur 13460",
    nohp: "8161114303",
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Nadia Dara",
  //   email: "benedictanadia22@gmail.com",
  //   anggota: null,
  //   code: "JKT 0003",
  //   jenis: "MB",
  //   alamat:
  //     "Jl. Raya Ciracas No. 30 RT 04/06,Kel. Ciracas. Kec. Ciracas, Jakarta Timur 13470",
  //   nohp: "8216120476",
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "Heru Pratama Sitepu",
    email: "pratama.siteru@gmail.com",
    anggota: null,
    code: "JKT 0004",
    jenis: "MB",
    alamat:
      "Jl. Karya Utama II No. 14 RT 02 RW 03 Kel. Srengseng, Kec. Kembangan, Jakarta Barat 1160",
    nohp: "82110599665",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Mochamad Fery Kurniawan",
    email: "kurniawanfery2@gmail.com",
    anggota: "IPCN",
    code: "JKT 0005",
    jenis: "MB",
    alamat:
      "Jl. Bukitduri tanjakan no 54 Wisma Ciliwung Blok H3 no 101 Kel. Bukit Duri, Kec. Tebet Jakarta Selatan 12840",
    nohp: "8125272118",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Musmuliadi",
    email: "dimus.muliadi@psplogistics.co.id",
    anggota: "IPCN",
    code: "JKT 0006",
    jenis: "MB",
    alamat:
      "Jl. Pintu II TMII Bawah No. 37A RT 15/03 Kel. Pinang Ranti, Kec. Makasar Jakarta Timur 13560",
    nohp: "85213646669",
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Nasrullah",
  //   email: "nasrullahyahya75@gmail.com",
  //   anggota: "IPCN",
  //   code: "JKT 0007",
  //   jenis: "MB",
  //   alamat:
  //     "Jl. Pepaya Raya No.87c RT.3/RW.5, Kel. Jagakarsa, Kec. Jagakarsa, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12620",
  //   nohp: "081323910219",
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "Hendra Gunawan",
    email: "rickyirawan061@gmail.com",
    anggota: null,
    code: "JKT 0008",
    jenis: "MB",
    alamat:
      "Jl. Bendungan Jago Raya RT 14/01 No. 1 Kel. Serdang Kec. Kemayoran, Jakarta Pusat 10650",
    nohp: "81222757689",
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Hadi Setiawan",
  //   email: "hadisetiawan309@gmail.com",
  //   anggota: null,
  //   code: "JKT 0009",
  //   jenis: "MB",
  //   alamat:
  //     "Jalan I Gusti Ngurah Rai Ruko 1 E Kel. Klender Kec. Duren Sawit, Jakarta Selatan 12750",
  //   nohp: "8977111186",
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "Benny Salomo",
    email: "bennysiahaan33@gmail.com",
    anggota: null,
    code: "JKT 0010",
    jenis: "MB",
    alamat:
      "Ruko Pasadena Blok A No 7 Kel. Cengkareng Timur Kec. Cengkareng Jakarta Barat 11730",
    nohp: "81219034155",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Rachmat",
    email: "rachmatrachmat068@gmail.com",
    anggota: null,
    code: "JKT 0011",
    jenis: "MB",
    alamat:
      "Jl. AL Bariah RT 10/04 No 19 Kel. Kampung Tengah, Kec. Kramat Jati, Jakarta Timur 13540",
    nohp: "82210225611",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Vemi Yudono",
    email: "vemiyudono1511@gmail.com",
    anggota: null,
    code: "JKT 0012",
    jenis: "MB",
    alamat:
      "Jl. Salihara No. 16 RT 1/1 Jati Padang, Pasar Minggu, Jakarta Selatan",
    nohp: "81296256768",
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Hadi Setiawan",
  //   nohp: 81290366805,
  //   email: "tantia.kurniawati@ppmkargo.com",
  //   anggota: "IPCN",
  //   jenis: "MB",
  //   code: "JKT 0013",
  //   alamat:
  //     "Jl. Rawajati Timur NO. AM14, Kel. Kalibata Indah, Kec. Pancoran, Jakarta Selatan 12750",
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "Yusuf",
    email: "yusuf@knpcargo.com",
    anggota: "IPCN",
    code: "JKT 0016",
    jenis: "MB",
    alamat:
      "Jl Kemanggisan Utama Raya No 3f RT 010/006 Kemanggisan Palmerah Jakarta Barat 11480",
    nohp: "81398011084",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Yeni Kristinawati",
    email: "srikandi_ne@yahoo.com",
    anggota: "IPCN",
    code: "TNG 0002",
    jenis: "MB",
    alamat:
      "Jl. Dr. Setiabudi No. 20 C Ruko Blok G No. 14 Rt 001/016 Kel. Pamulang Timut Kec. Pamulang Kota Tangerang Selatan - Banten 15417",
    nohp: "85810844855",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Abdul Soleh Ibnu Asya, SE",
    email: "mascargoexpress@gmail.com",
    anggota: "IPCN",
    code: "TNG 0003",
    jenis: "MB",
    alamat:
      "Ruko Duta Garden Jl. Husein Sastranegara No. 07 RT 27/08 Kel. Jurumudi Kec.Benda Kota Tangerang 15124",
    nohp: "82111222338",
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Yeni Kristinawati",
  //   email: "srikandi_ne@gmail.com",
  //   anggota: "IPCN",
  //   code: "TNG 0004",
  //   jenis: "MB",
  //   alamat:
  //     "JL. Eco Polis Boulevard Blok ve 1/23 R, Kel. Citra Raya Kec. Cikupa, Pamulang, Tangerang Selatan 15710",
  //   nohp: "81314808089",
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "Bu Rahma",
    email: "srikandi_ne@gmail.com",
    anggota: "IPCN",
    code: "TNG 0005",
    jenis: "MB",
    alamat:
      "Jl. KH. Ahmad Dahlan No.16, Petir, Kec. Cipondoh, Kota Tangerang, Banten 15147",
    nohp: "81314808089",
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Doni",
  //   email: "radologistik@gmail.com",
  //   anggota: "IPCN",
  //   code: "TNG 0008",
  //   jenis: "MB",
  //   alamat:
  //     "Perumahan palem ganda asri 2 ruko cluster DD blok A 2 no 2 Kel. Karang Mulya Kec. karang tengah, Tangerang 15157",
  //   nohp: "81213145411",
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "Hodbin Harrys",
    email: "harrysbisnis@gmail.com",
    anggota: null,
    code: "TNG 0009",
    jenis: "MB",
    alamat:
      "Duta Bintaro Blok B2/24 No. 1, Kel. Kunciran Kec. Pinang Tangerang 15220",
    nohp: "81210361600",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Agus Suminto & H. Burhan",
    nohp: 5113260423,
    email: "agussuminto75@gmail.com / burhan383@gmail.com",
    anggota: "IPCN",
    jenis: "MB",
    code: "BJM 0001",
    alamat: "Jl. Krisna 2 No. 8 Beruntung jaya, Banjarmasin 70238",
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Michael",
  //   email: "ptmitasuksesmandiri@gmail.com",
  //   anggota: "IPCN",
  //   jenis: "MB",
  //   code: "BATAM",
  //   alamat:
  //     "oceanic blizz Ruko Oriental Blok AC no.1, Pasir Putih, Batam 29432",
  //   nohp: 81378776734,
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "Deva Gusti Nanda SH",
    nohp: 81371377818,
    email: "rdx_office@yahoo.com",
    anggota: "IPCN",
    jenis: "MB",
    code: "PKU 0002",
    alamat:
      "Jl. Dirgantara no. 15 Kel. Sidomulyo kec. Marpoyan Damai, Pekanbaru",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "PBS TRANS",
    email: "pirantiberkashsejahtera@yahoo.com",
    anggota: "IPCN",
    jenis: "MB",
    code: "SMG 0000",
    alamat:
      "Jl Mintojiwo timur 1 no 1c Kel. Gisikdrono , kec. Semarang Barat, Kota Semarang 50149",
    nohp: 81326268811,
    gmaps: "Gmaps",
    ready: true,
  },
  // {
  //   name: "Egia K.E.P Sinulaki",
  //   email: "egiakaritamasinulaki@gmail.com",
  //   anggota: null,
  //   jenis: "MB",
  //   code: "TNG 0001",
  //   alamat:
  //     "Jl. Alumunium Raya No. 12 Kel. Cibodas Baru Kec. Cibodas, Tangerang, Banten 15810",
  //   nohp: 82112520458,
  //   gmaps: "Gmaps",
  //   ready: true,
  // },
  {
    name: "MB Aero",
    nohp: "85299986241",
    email: "MbAero@gmail.com",
    anggota: null,
    jenis: "MB",
    code: "UPG 0001",
    alamat:
      "Jl. Raya Kapasa, Komp. Pagodam, Blok F2, Blok F15 - 16, Daya, Kec. Biringkanaya, Kota Makassar, Sulawesi Selatan 90241",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "ADIN GLOBALPACK",
    nohp: "87817099982",
    email: "MBGLOBALPACK@GMAIL.COM",
    anggota: null,
    jenis: "MB",
    code: "UPG 0002",
    alamat: "Jl. komp. ruko pagodam blok RD. No. 8 makassar",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Mutiara Trans",
    nohp: "81342235327",
    email: "mutiaratransmb@gmail.com",
    anggota: null,
    jenis: "MB",
    code: "UPG 0003",
    alamat:
      "Jl. Sultan Dg. No.45, Timungan Lompoa, Kec. Bontoala, Kota Makassar, Sulawesi Selatan 90151",
    gmaps: "Gmaps",
    ready: true,
  },
  {
    name: "Klik Makassar",
    nohp: "813423197777",
    email: "klikmakassar@gmail.com",
    anggota: null,
    jenis: "MB",
    code: "UPG 0005",
    alamat:
      "Jl. Teuku Umar Raya No.68, Kaluku Bodoa, Kec. Tallo, Kota Makassar, Sulawesi Selatan 90212",
    gmaps: "Gmaps",
    ready: true,
  },
];
